<template>
	<div class="container-integration">
		<div class="container-integration-content">
			<div class="plugin" v-if="icon"><em :class="icon"></em></div>
			<span class="title">{{ title }}</span>
			<span class="content">
				<slot />
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'card-erp-default',
	props: {
		icon: {
			type: String,
		},
		title: {
			type: String,
			required: true,
		},
	},
}
</script>

<style lang='stylus' scoped>
@import './styles.styl';
</style>
